import React from "react";
import classNames from "classnames";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import { LogRenderContext } from "../LogRenderer";
import CampaignDetailsPanel from "../createEvents/CampaignTab";
import GetUpdatedOnBy from "../GetUpdatedOnBy";

const CampaignUpdate = () => {
  const { log } = React.useContext(LogRenderContext);
  const campaignName = log.dataSnapshot?.campaign?.name;
  const updatedAt = log.changedFields?.campaign?.updatedAt;
  const updatedBy = log.changedFields?.campaign?.updatedBy;

  return (
    <div className={styles.tabContainer}>
      <div className={styles.badgeContainer}>
        {!!campaignName && <div className={styles.campaignName}>{campaignName}</div>}
        <div className={classNames(styles.badge, styles.badgeUpdated)}>
          <div>Updated</div>
        </div>
      </div>
      <GetUpdatedOnBy updatedAt={updatedAt} updatedBy={updatedBy} />
      <CampaignDetailsPanel />
    </div>
  );
};

export default CampaignUpdate;
